// Generates specific languagefields on specified fields. Eg. text_sv, text_en etc.
// Saves original value in _text-field since
// Generates getters/setters for field. question.text = "Test" will generate question.text_en = "Test" if language_override has been set to "en"
// If no language_override is set, the original field will be used

export const TranslatableFieldsMixin = {
  applyTranslation(modelInstance, translatableFields, rest, languages) {

    // 1) Generera språkfält (ex: text_nb, info_en, etc)
    Object.keys(languages).forEach((code) => {
      const normalized = code.replace("-", "_");
      translatableFields.forEach((baseKey) => {
        const langKey = `${baseKey}_${normalized}`;
        modelInstance[langKey] = rest[langKey] ?? modelInstance[langKey] ?? "";
      });
    });

    // 2) Spara rå-originalvärden **innan** getters sätts
    const rawOriginal = {};
    translatableFields.forEach((baseKey) => {
      rawOriginal[baseKey] = modelInstance[baseKey]; // ← denna rad körs innan getter finns
    });

    // 3) Nu skapar vi getters/setters
    translatableFields.forEach((baseKey) => {

      Object.defineProperty(modelInstance, baseKey, {
        get() {
          const lang = this.language_override?.replace("-", "_");
          if (lang) {
            const key = `${baseKey}_${lang}`;
            return this[key] || rawOriginal[baseKey];
          }
          return rawOriginal[baseKey];
        },

        set(value) {
          const lang = this.language_override?.replace("-", "_");
          if (lang) {
            const key = `${baseKey}_${lang}`;
            this[key] = value;
          } else {
            rawOriginal[baseKey] = value;
          }
        },

        enumerable: true,
        configurable: true,
      });

    });
  }
};